export default __webpack_public_path__ + "static/media/7.6684e997.jpg";